import { SINGLE_MUNICIPALITY_ID } from '../Constants';

// Always resolves to a real id: either the pinned SINGLE_MUNICIPALITY_ID, or the route's
// own ':municipalitaId' param - one of the two is always present for a matched route.
export function resolveMunicipalityId(paramMunicipalitaId?: string): string {
    return (SINGLE_MUNICIPALITY_ID ?? paramMunicipalitaId) as string;
}

export function buildCouncilPath(
    municipalitaId: string,
    bodyType?: string,
    zastupitelstvoId?: string | number,
    ...segments: Array<string | number>
): string {
    const prefix = SINGLE_MUNICIPALITY_ID ? [] : [municipalitaId];
    return (
        '/' +
        [...prefix, bodyType, zastupitelstvoId, ...segments]
            .filter((segment) => segment !== undefined && segment !== null && segment !== '')
            .join('/')
    );
}
